/**
 * Conversões de apresentação.
 *
 * Spec funcional §2.2: m³ é a unidade canônica e a ÚNICA armazenada. m², metro
 * linear, peça e pé-tábua são calculados na borda, para exibir. Nada aqui volta
 * para o banco — se voltasse, seria a mesma quantidade guardada em duas
 * unidades, que é exatamente como nasce a divergência que ninguém explica.
 */
import { Volume } from "./grandezas.js";
import { Decimal, ErroDominio, paraDecimal } from "./numero.js";
/** 1 pé-tábua = 144 pol³ = 0,002359737216 m³ */
const M3_POR_PE_TABUA = new Decimal("0.002359737216");
/** Volume de uma única peça, em m³. */
export function volumeDaPeca(d) {
    const esp = paraDecimal(d.esp_mm, "Esp. (mm)").dividedBy(1000);
    const larg = paraDecimal(d.larg_mm, "Larg. (mm)").dividedBy(1000);
    const comp = paraDecimal(d.comp_m, "Comp. (m)");
    return Volume.deM3(esp.times(larg).times(comp));
}
/**
 * Quantas peças desta bitola cabem no volume.
 *
 * Devolve fração, não inteiro: arredondar aqui esconderia sobra. Quem precisa de
 * peça inteira arredonda na tela, e vê o resto.
 */
export function pecasEquivalentes(v, d) {
    const unit = volumeDaPeca(d);
    if (unit.ehZero())
        throw new ErroDominio("bitola com volume zero");
    return v.interno().dividedBy(unit.interno());
}
/** Área de superfície (m²) — largura × comprimento × peças. */
export function areaEmM2(larg_mm, comp_m, pecas) {
    const larg = paraDecimal(larg_mm, "Larg. (mm)").dividedBy(1000);
    const comp = paraDecimal(comp_m, "Comp. (m)");
    const n = paraDecimal(pecas, "Peças");
    return larg.times(comp).times(n);
}
/** Metros lineares — comprimento × peças. */
export function metrosLineares(comp_m, pecas) {
    return paraDecimal(comp_m, "Comp. (m)").times(paraDecimal(pecas, "Peças"));
}
/** Pé-tábua (board foot) — usado em exportação. */
export function emPeTabua(v) {
    return v.interno().dividedBy(M3_POR_PE_TABUA);
}
/** Peso estimado, a partir da densidade aparente da espécie em kg/m³. */
export function pesoEstimadoKg(v, densidadeKgM3) {
    const dens = paraDecimal(densidadeKgM3, "densidade");
    if (dens.isNegative())
        throw new ErroDominio("densidade negativa");
    return v.interno().times(dens);
}
//# sourceMappingURL=conversao.js.map